<template>
    <v-dialog v-model="isVisible" max-width="600">
		<p-card class="tw-p-none overflow-hidden">
			<p-header-dialog :negative-margin="false" @closeClicked="close()">
				Agregar Nueva Área
			</p-header-dialog>
			<section class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-p-4">
				<label :style="`color:${$appColors.info}; width: 100%;`">Nombre:
					<v-text-field
						label="Nombre"
						solo
						hide-details
						class="input-text"
						v-model="area.name"
					></v-text-field>
					<span
						v-if="$v.area.name.$invalid"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El nombre es requerido
					</span>
				</label>
				<label :style="`color:${$appColors.info}; width: 100%;`">Código:
					<v-text-field
						label="Código"
						solo
						hide-details
						class="input-text"
						v-model="area.code"
					></v-text-field>
					<span
						v-if="!$v.area.code.required"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El código es requerido
					</span>
					<span
						v-if="!$v.area.code.maxLength"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El código debe tener máximo 4 caracteres
					</span>
				</label>
			</section>
			<p-horizontal-divider></p-horizontal-divider>
			<div class="tw-flex tw-justify-center tw-items-center tw-pb-4">
				<p-button
					:disabled="fieldsNone"
					type="primary"
					@click="saveNewArea"
					> Guardar
				</p-button>
			</div>
		</p-card>
    </v-dialog>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import PButton from '@/modules/shared/components/ui/p-button';
import PHeaderDialog from '@/modules/shared/components/ui/dialog/p-header-dialog';
import { required, maxLength } from 'vuelidate/lib/validators';


function validations() {
	return {
		area: {
			name: { required },
			code: { required, maxLength: maxLength(4) },
		},
	};
}

export default {
	name: 'add-area-dialog',
	data() {
		return {
			isVisible: false,
			area: {
				name: null,
				code: null,
			},
		};
	},
	validations,
	components: { PHeaderDialog, PButton, CloseIcon, PCard, PHorizontalDivider },
	methods: {
		saveNewArea() {
			this.$emit('addNewArea', this.area);
			this.close();
		},
		open() {
			this.isVisible = true;
		},
		close() {
			this.isVisible = false;
		},
	},
	computed: {
		fieldsNone() {
			return !this.area.name || !this.area.code || !this.$v.area.code.maxLength;
		},
	},
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/job-info-edition/add-area-dialog.vue